<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
<app-ion-common-label class="document-type-label1" labelStyle="display-rg"
  labelDescription="Nome que quer usar"
  label="Pode ser um apelido ou nome social">
</app-ion-common-label>

<form [formGroup]="nameForm" (ngSubmit)="submitForm($event)">
  <div class="conent-center conent-center--mrt-lg">
      <app-ion-common-input
        [placeholder]="placeholder" 
        [error]="error" 
        [id]="idComponentName"
        [textError]="textError"
        maxLength="51"
        (textChange)="name=$event; errorMsg();"
        type="text"
        [fieldValue]="name"
        [idLabel]="idLabel"
        [replaceStrTo]="'name'"
        [label]="label"
        name="docName"
        [disabled]="!this.edit"
        formControlName="docName"
        ngDefaultControl>
      </app-ion-common-input>
    </div>
  </form>
  <app-ion-common-button class="hidden" [id]="headerId + '-btn-go'" [ngClass]="{'hidden': !buttonEnable || name.length === 0}" [attr.aria-hidden]="!buttonEnable" (clickButton)="clickNext();" label="Continuar"></app-ion-common-button>
</ion-content>